<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)" class="tamara-link" @click="handleClick">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    trackId: {
      type: String,
      default: '',
    },
    trackPayload: {
      type: Object,
      default: () => ({}),
    },
    trackOnce: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener',
        }
      }
      return {
        is: 'router-link',
        to: url,
      }
    },
    handleTrackEvent() {
      const eventName = `${this.trackId}_clicked`
      const payload = {
        link_url: this.to,
        ...this.trackPayload,
      }

      if (this.trackOnce) {
        this.$track.trackOnce(eventName, payload)
      } else {
        this.$track.event(eventName, payload)
      }
    },
    handleClick(event) {
      if (this.trackId) {
        this.handleTrackEvent()
      }
      this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.tamara-link {
  display: flex;
  gap: 2px;
  align-items: center;
  color: #4a0089;
  text-decoration: underline;
  text-decoration-thickness: 0;
  text-decoration-color: #4a0089;
  text-underline-offset: 0;
  text-decoration-skip-ink: true;
}
</style>
